import { Grid,Stack,TextField } from "@mui/material";
import { useMask } from "@react-input/mask";
import { useContext,useState } from "react";
import { useTranslation } from "react-i18next";
import { NewFormContext } from "../../../context/NewFormContext";
import CepService from "../../../service/CepService";
import { ChecklistSubitem,ChecklistType } from "../../../types/checklist/types";

type props = {
  subitem: ChecklistSubitem;
  itemId: string;
  indexSubitem: number
};

const Cep = ({ subitem, itemId, indexSubitem }: props) => {
  const { setModelo } = useContext(NewFormContext);
  const [isValidCep, setIsValidCep] = useState<boolean | null>(null);
  const cepRef = useMask({ mask: '_____-___', replacement: { _: /\d/ } });
  const cepService = new CepService();
  const { t } = useTranslation('translation');

  const verificarCep = async (value: string) => {
    if (value.length === 9) {
      const isValid = await cepService.ValidaCep(value as string);
      setIsValidCep(isValid);
    } else {
      setIsValidCep(null);
    }
  };

  function handleValue(value: string) {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem, padrao: value
                } : subitem
            )
          }
          : item
      )
    }));
  }

  return (
    <Stack direction='row' justifyContent='flex-start' alignItems='flex-start' width='100%'>
      <Grid container spacing={1} width='100%'>
        <Grid size={4}>
          <TextField
            fullWidth
            error={isValidCep === false}
            helperText={isValidCep === false ? t('cepInvalid') : null}
            inputRef={cepRef}
            value={subitem.padrao}
            onChange={(event) => { handleValue(event.target.value); verificarCep(event.target.value); }}
            label='Valor padrão' />
        </Grid>
        <Grid size={4}>
        </Grid>
      </Grid>
    </Stack >
  );
};

export default Cep;